import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import '../../shared/utils/classes/storage/localStorage.js';
import 'viem';
import '../../shared/consts/index.js';
import '../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/multi-wallet';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '@dynamic-labs/rpc-providers';
import '../../utils/hooks/useWallets/utils/verifyMagicIsSetup/verifyMagicIsSetup.js';
import '../../context/ErrorContext/ErrorContext.js';
import '../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../context/AccountExistsContext/AccountExistsContext.js';
import { DynamicAuthLayout } from '../../layout/DynamicAuthLayout/DynamicAuthLayout.js';
import '../../components/OverlayCard/OverlayCard.context.js';
import '../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../context/EmailVerificationContext/EmailVerificationContext.js';
import 'qrcode';
import '../../context/QrCodeContext/QrCodeContext.js';
import '../../context/LoadingContext/LoadingContext.js';
import '../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import 'react-i18next';
import '../../views/CollectUserDataView/fieldsConfig.js';
import '../../components/UserProfile/parts/UserProfileField/components/VerifiedEmailIcon/VerifiedEmailIcon.js';
import '@dynamic-labs/types';
import '../../utils/hooks/useUserUpdateRequest/useUpdateUser/useUpdateUser.js';
import '../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import 'formik';
import 'yup';
import '../../context/MockContext/MockContext.js';
import '../../components/IconButton/IconButton.js';
import '../../components/Alert/Alert.js';
import { WalletProgressStepper } from '../../layout/DynamicAuthLayout/WalletProgressStepper/WalletProgressStepper.js';
import { useAuthLayoutChecks } from '../../utils/hooks/useAuthLayoutChecks/useAuthLayoutChecks.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import { Modal } from '../../components/Modal/Modal.js';
import { ModalCard } from '../../components/ModalCard/ModalCard.js';
import '../../components/InlineWidget/InlineWidget.js';
import '../../components/MenuList/Dropdown/Dropdown.js';

const DynamicAuthModal = ({ children, onClose, transitionProps, walletConnector, projectSettings, className, }) => {
    const { showConnectedWalletProgress } = useAuthLayoutChecks(walletConnector);
    return (jsxs(Modal, { isShown: Boolean(transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.isShown), children: [showConnectedWalletProgress && (jsx(ModalCard, { borderRadius: 'small', children: jsx(WalletProgressStepper, {}) })), jsx(ModalCard, { dataTestId: 'dynamic-auth-modal', children: jsx(DynamicAuthLayout, { className: className, projectSettings: projectSettings, onClose: onClose, hideBridgeProgressSteppers: true, children: children }) })] }));
};

export { DynamicAuthModal };
